import FulfillmentStatus from 'components/OrderConfirmation/FulfillmentStatus/FulfillmentStatus';

export default FulfillmentStatus;
